
export const timeRangeOptions = [
  { value: 'yearly', label: 'Time Range: Yearly' },
  { value: 'monthly', label: 'Time Range: Monthly' },
  { value: 'weekly', label: 'Time Range: Weekly' },
  { value: 'daily', label: 'Time Range: Daily' },
];
